import { emptyScript } from "./builder/ast.js";
import { generateScript, splitManagedVacationHeader } from "./builder/generate.js";
import { parseScript } from "./builder/parse.js";
import { renderBuilderUi } from "./builder/ui.js";
import { el } from "./dom.js";
import { createScriptWorkspace } from "./scriptWorkspace.js";
export function renderScriptingPanel(options) {
    const wrap = el("div", "sieve-scripting");
    const editorSlot = el("div", "sieve-scripting-editor sieve-editor-locked");
    const tabs = el("div", "sieve-tabs");
    const scriptTabBtn = el("button", "btn btn-secondary btn-sm sieve-tab active", "Script");
    scriptTabBtn.type = "button";
    const sourceTabBtn = el("button", "btn btn-secondary btn-sm sieve-tab", "Source");
    sourceTabBtn.type = "button";
    tabs.append(scriptTabBtn, sourceTabBtn);
    const scriptPane = el("div", "sieve-tab-pane");
    const sourcePane = el("div", "sieve-tab-pane");
    sourcePane.hidden = true;
    const sourceEditor = el("textarea", "input sieve-editor sieve-source-editor");
    sourceEditor.rows = 14;
    sourceEditor.spellcheck = false;
    sourceEditor.disabled = true;
    sourceEditor.readOnly = true;
    sourcePane.append(sourceEditor);
    const parseError = el("p", "flash flash-error");
    parseError.hidden = true;
    editorSlot.append(tabs, parseError, scriptPane, sourcePane);
    let ast = emptyScript();
    let activeTab = "script";
    let managedHeader = "";
    let suppressSourceSync = false;
    let editorEnabled = false;
    let workspaceRef = null;
    const rebuildScriptPane = () => {
        scriptPane.replaceChildren(renderBuilderUi({
            capabilities: options.capabilities,
            ast,
            enabled: editorEnabled,
            onChange: (next) => {
                if (!editorEnabled)
                    return;
                ast = next;
                suppressSourceSync = true;
                sourceEditor.value = generateScript(ast, {
                    preserveHeader: managedHeader || undefined,
                });
                suppressSourceSync = false;
                parseError.hidden = true;
                workspaceRef?.markDirty();
                rebuildScriptPane();
            },
        }));
    };
    const loadFromSource = (content, showErrors) => {
        const split = splitManagedVacationHeader(content);
        managedHeader = split.header;
        const body = split.body;
        const useParsed = split.header ? parseScript(body) : parseScript(body || content);
        ast = useParsed;
        rebuildScriptPane();
        if (useParsed.partial && showErrors) {
            parseError.textContent =
                "Some parts of this script are shown as opaque blocks. You can still edit them in Source.";
            parseError.hidden = false;
        }
        else {
            parseError.hidden = true;
        }
    };
    const showTab = (tab) => {
        if (!editorEnabled)
            return;
        if (tab === "script" && activeTab === "source") {
            loadFromSource(sourceEditor.value, true);
        }
        if (tab === "source" && activeTab === "script") {
            suppressSourceSync = true;
            sourceEditor.value = generateScript(ast, {
                preserveHeader: managedHeader || undefined,
            });
            suppressSourceSync = false;
        }
        activeTab = tab;
        scriptTabBtn.classList.toggle("active", tab === "script");
        sourceTabBtn.classList.toggle("active", tab === "source");
        scriptPane.hidden = tab !== "script";
        sourcePane.hidden = tab !== "source";
    };
    scriptTabBtn.addEventListener("click", () => showTab("script"));
    sourceTabBtn.addEventListener("click", () => showTab("source"));
    sourceEditor.addEventListener("input", () => {
        if (suppressSourceSync || !editorEnabled)
            return;
        workspaceRef?.markDirty();
    });
    const workspace = createScriptWorkspace({
        storage: options.storage,
        root: options.root,
        showStatus: options.showStatus,
        editorSlot,
        hint: "Select a script, then use Script for drag-and-drop editing or Source for raw text.",
        onSelectionChange: (name) => {
            editorEnabled = !!name;
            scriptTabBtn.disabled = !editorEnabled;
            sourceTabBtn.disabled = !editorEnabled;
            if (!name) {
                ast = emptyScript();
                managedHeader = "";
                suppressSourceSync = true;
                sourceEditor.value = "";
                suppressSourceSync = false;
                parseError.hidden = true;
                activeTab = "script";
                scriptTabBtn.classList.add("active");
                sourceTabBtn.classList.remove("active");
                scriptPane.hidden = false;
                sourcePane.hidden = true;
                rebuildScriptPane();
            }
        },
        onScriptContent: (name, content) => {
            if (!name)
                return;
            // Selection was enabled first; load content into the Script builder immediately.
            suppressSourceSync = true;
            sourceEditor.value = content;
            suppressSourceSync = false;
            loadFromSource(content, false);
            workspaceRef?.markClean();
        },
        onBeforeSave: () => {
            if (!editorEnabled || activeTab !== "script")
                return;
            suppressSourceSync = true;
            sourceEditor.value = generateScript(ast, {
                preserveHeader: managedHeader || undefined,
            });
            suppressSourceSync = false;
        },
    });
    workspaceRef = workspace;
    rebuildScriptPane();
    wrap.append(workspace.element);
    void workspace.refresh();
    return {
        element: wrap,
        confirmDiscardIfDirty: () => workspace.confirmDiscardIfDirty(),
    };
}
